import { Outlet } from 'react-router-dom';
import {
  LayoutDashboard, Building2, CreditCard, AlertTriangle,
  TrendingUp, Users, Settings, BookOpen
} from 'lucide-react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { useShop } from '../../hooks/useShop';
import { useDashboard } from '../../hooks/useDashboard';
import { useAuth } from '../../contexts/AuthContext';

export default function SuperAdminShell() {
  const { user } = useAuth();
  const { shops, currentShopId, switchShop } = useShop();
  const { data: dashboard, loading, refresh } = useDashboard(currentShopId);

  const sections = [
    {
      label: 'Oversight',
      items: [
        { to: '/admin', end: true, label: 'Org Dashboard', icon: <LayoutDashboard /> },
        { to: '/admin/shops', label: 'All Shops', icon: <Building2 /> },
        { to: '/admin/ach-queue', label: 'ACH Queue', icon: <CreditCard />, badge: 4 },
        { to: '/admin/escalations', label: 'Escalations', icon: <AlertTriangle />, badge: 2 },
      ],
    },
    {
      label: 'Insights',
      items: [
        { to: '/admin/trends', label: 'Recovery Trends', icon: <TrendingUp /> },
        { to: '/admin/users', label: 'Users & Roles', icon: <Users /> },
      ],
    },
    {
      label: 'System',
      items: [
        { to: '/admin/audit-trail', label: 'Audit Trail', icon: <BookOpen /> },
        { to: '/admin/settings', label: 'Settings', icon: <Settings /> },
      ],
    },
  ];

  return (
    <div className="min-h-screen flex bg-[var(--color-cream-100)] font-sans">
      <Sidebar
        brand={{ initials: 'R', name: 'Reconciliation Hub', tagline: 'Admin workspace' }}
        sections={sections}
      />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar
          user={user || {}}
          currentShop={currentShopId}
          shops={shops}
          onShopChange={switchShop}
          notifications={0}
          onRefresh={refresh}
        />
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-[1400px] mx-auto px-6 py-8">
            <Outlet context={{ dashboard, loading, refresh }} />
          </div>
        </main>
      </div>
    </div>
  );
}
